var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 780,
    viewBox: "0 0 1441 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 780,
    transform: "translate(0.976562)",
    fill: "#FAF8F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M772.511 45.1705C744.049 45.1705 720.976 68.2435 720.976 96.7056H824.046C824.046 68.2435 800.973 45.1705 772.511 45.1705Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.511 45.1705C800.973 45.1705 824.046 22.0975 824.046 -6.36449L720.976 -6.3645C720.976 22.0975 744.049 45.1705 772.511 45.1705Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 45.1705C1001.72 45.1705 978.65 68.2435 978.65 96.7056H1081.72C1081.72 68.2435 1058.65 45.1705 1030.19 45.1705Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 45.1705C1058.65 45.1705 1081.72 22.0975 1081.72 -6.36449L978.651 -6.3645C978.651 22.0975 1001.72 45.1705 1030.19 45.1705Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.65 45.1706C978.65 16.7086 955.577 -6.36438 927.115 -6.36438L927.115 96.7057C955.577 96.7057 978.65 73.6326 978.65 45.1706Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.581 45.1705C847.119 45.1705 824.046 68.2435 824.046 96.7056H927.116C927.116 68.2435 904.043 45.1705 875.581 45.1705Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 355.211C1058.65 355.211 1081.72 378.284 1081.72 406.746H978.652C978.652 378.284 1001.72 355.211 1030.19 355.211Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 355.211C1001.72 355.211 978.651 332.138 978.651 303.676L1081.72 303.676C1081.72 332.138 1058.65 355.211 1030.19 355.211Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 252.141C1001.72 252.141 978.651 229.068 978.651 200.606L1081.72 200.606C1081.72 229.068 1058.65 252.141 1030.19 252.141Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 149.071C1030.19 120.609 1053.26 97.5355 1081.72 97.5355L1081.72 200.606C1053.26 200.606 1030.19 177.533 1030.19 149.071Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.116 252.141C898.654 252.141 875.581 229.068 875.581 200.606L978.651 200.606C978.651 229.068 955.578 252.141 927.116 252.141Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 149.071C1030.19 177.533 1007.11 200.606 978.652 200.606L978.652 97.5358C1007.11 97.5358 1030.19 120.609 1030.19 149.071Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.115 97.5358C955.577 97.5358 978.65 120.609 978.65 149.071H875.58C875.58 120.609 898.653 97.5358 927.115 97.5358Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.58 252.141C875.58 223.679 852.507 200.606 824.045 200.606L824.045 303.676C852.507 303.676 875.58 280.603 875.58 252.141Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.512 355.211C800.974 355.211 824.047 378.284 824.047 406.746H720.977C720.977 378.284 744.05 355.211 772.512 355.211Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.512 355.211C744.05 355.211 720.977 332.138 720.977 303.676L824.047 303.676C824.047 332.138 800.974 355.211 772.512 355.211Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.512 252.141C744.05 252.141 720.977 229.068 720.977 200.606L824.047 200.606C824.047 229.068 800.974 252.141 772.512 252.141Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.045 200.606C795.583 200.606 772.51 177.533 772.51 149.071L875.58 149.071C875.58 177.533 852.507 200.606 824.045 200.606Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.51 149.071C772.51 177.533 749.437 200.606 720.975 200.606L720.975 97.5356C749.437 97.5356 772.51 120.609 772.51 149.071Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.047 355.211C824.047 326.749 847.12 303.676 875.582 303.676L875.582 406.746C847.12 406.746 824.047 383.673 824.047 355.211Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.116 355.211C955.578 355.211 978.651 378.284 978.651 406.746H875.581C875.581 378.284 898.654 355.211 927.116 355.211Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.116 252.141C955.578 252.141 978.651 275.214 978.651 303.676H875.581C875.581 275.214 898.654 252.141 927.116 252.141Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 45.1708C1133.26 73.6328 1110.19 96.7058 1081.72 96.7058L1081.72 -6.36423C1110.19 -6.36423 1133.26 16.7088 1133.26 45.1708Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 45.1705C1133.26 16.7085 1156.33 -6.3645 1184.79 -6.3645L1184.79 96.7055C1156.33 96.7055 1133.26 73.6325 1133.26 45.1705Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 96.7056C1207.87 96.7056 1184.79 73.6326 1184.79 45.1705L1287.86 45.1705C1287.86 73.6326 1264.79 96.7056 1236.33 96.7056Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.4 -6.36425C1367.86 -6.36426 1390.93 16.7088 1390.93 45.1708L1287.86 45.1708C1287.86 16.7088 1310.94 -6.36425 1339.4 -6.36425Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 45.1708C1390.93 16.7088 1414.01 -6.36426 1442.47 -6.36426L1442.47 96.7058C1414.01 96.7058 1390.93 73.6328 1390.93 45.1708Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 355.21C1419.4 355.21 1442.47 378.283 1442.47 406.745H1339.4C1339.4 378.283 1362.47 355.21 1390.93 355.21Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 355.21C1362.47 355.21 1339.4 332.137 1339.4 303.675L1442.47 303.675C1442.47 332.137 1419.4 355.21 1390.93 355.21Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 252.141C1362.47 252.141 1339.4 229.068 1339.4 200.606L1442.47 200.606C1442.47 229.068 1419.4 252.141 1390.93 252.141Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 149.071C1390.93 120.609 1414.01 97.5355 1442.47 97.5355L1442.47 200.606C1414.01 200.606 1390.93 177.533 1390.93 149.071Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 252.141C1259.4 252.141 1236.33 229.068 1236.33 200.606L1339.4 200.606C1339.4 229.068 1316.33 252.141 1287.86 252.141Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 149.071C1390.93 177.533 1367.86 200.606 1339.4 200.606L1339.4 97.5358C1367.86 97.5358 1390.93 120.609 1390.93 149.071Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 97.5356C1316.33 97.5356 1339.4 120.609 1339.4 149.071H1236.33C1236.33 120.609 1259.4 97.5356 1287.86 97.5356Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 252.141C1236.33 223.679 1213.26 200.606 1184.79 200.606L1184.79 303.676C1213.26 303.676 1236.33 280.603 1236.33 252.141Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 355.21C1161.72 355.21 1184.79 378.283 1184.79 406.745H1081.72C1081.72 378.283 1104.8 355.21 1133.26 355.21Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 355.21C1104.8 355.21 1081.72 332.137 1081.72 303.675L1184.79 303.675C1184.79 332.137 1161.72 355.21 1133.26 355.21Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 252.141C1104.8 252.141 1081.72 229.068 1081.72 200.606L1184.79 200.606C1184.79 229.068 1161.72 252.141 1133.26 252.141Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.79 200.606C1156.33 200.606 1133.26 177.533 1133.26 149.071L1236.33 149.071C1236.33 177.533 1213.25 200.606 1184.79 200.606Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 149.071C1133.26 177.533 1110.18 200.606 1081.72 200.606L1081.72 97.5356C1110.18 97.5356 1133.26 120.609 1133.26 149.071Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.79 355.211C1184.79 326.749 1207.87 303.676 1236.33 303.676L1236.33 406.746C1207.87 406.746 1184.79 383.673 1184.79 355.211Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 355.21C1316.33 355.21 1339.4 378.283 1339.4 406.745H1236.33C1236.33 378.283 1259.4 355.21 1287.86 355.21Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 252.141C1316.33 252.141 1339.4 275.214 1339.4 303.676H1236.33C1236.33 275.214 1259.4 252.141 1287.86 252.141Z",
    fill: "#DED9D5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0194 45.1705C22.5574 45.1705 -0.515625 68.2435 -0.515625 96.7056H102.554C102.554 68.2435 79.4814 45.1705 51.0194 45.1705Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0197 45.1705C79.4817 45.1705 102.555 22.0975 102.555 -6.36449L-0.515346 -6.3645C-0.515348 22.0975 22.5577 45.1705 51.0197 45.1705Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.694 45.1705C280.232 45.1705 257.159 68.2435 257.159 96.7056H360.229C360.229 68.2435 337.156 45.1705 308.694 45.1705Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.694 45.1705C337.156 45.1705 360.229 22.0975 360.229 -6.36449L257.159 -6.3645C257.159 22.0975 280.232 45.1705 308.694 45.1705Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.159 45.1706C257.159 16.7086 234.086 -6.36438 205.624 -6.36438L205.624 96.7057C234.086 96.7057 257.159 73.6326 257.159 45.1706Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09 45.1705C125.628 45.1705 102.555 68.2435 102.555 96.7056H205.625C205.625 68.2435 182.552 45.1705 154.09 45.1705Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 355.21C337.158 355.21 360.231 378.283 360.231 406.745H257.161C257.161 378.283 280.234 355.21 308.696 355.21Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 355.21C280.234 355.21 257.161 332.137 257.161 303.675L360.231 303.675C360.231 332.137 337.158 355.21 308.696 355.21Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 252.14C280.234 252.141 257.161 229.067 257.161 200.605L360.231 200.605C360.231 229.067 337.158 252.14 308.696 252.14Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.695 149.07C308.695 120.608 331.768 97.5354 360.23 97.5354L360.23 200.605C331.768 200.605 308.695 177.532 308.695 149.07Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 252.14C177.164 252.141 154.091 229.067 154.091 200.605L257.161 200.605C257.161 229.067 234.088 252.14 205.626 252.14Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 149.071C308.696 177.533 285.623 200.606 257.161 200.606L257.161 97.5357C285.623 97.5357 308.696 120.609 308.696 149.071Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.625 97.5356C234.087 97.5356 257.16 120.609 257.16 149.071H154.09C154.09 120.609 177.163 97.5356 205.625 97.5356Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09 252.141C154.09 223.679 131.017 200.606 102.555 200.606L102.555 303.676C131.017 303.676 154.09 280.603 154.09 252.141Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0216 355.21C79.4836 355.21 102.557 378.283 102.557 406.745H-0.513397C-0.513397 378.283 22.5596 355.21 51.0216 355.21Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0213 355.21C22.5593 355.21 -0.513674 332.137 -0.513676 303.675L102.556 303.675C102.556 332.137 79.4834 355.21 51.0213 355.21Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0213 252.14C22.5593 252.141 -0.513674 229.067 -0.513676 200.605L102.556 200.605C102.556 229.067 79.4834 252.14 51.0213 252.14Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.555 200.605C74.0925 200.605 51.0195 177.532 51.0195 149.07L154.09 149.07C154.09 177.532 131.017 200.605 102.555 200.605Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0195 149.07C51.0195 177.532 27.9465 200.605 -0.515488 200.605L-0.515483 97.5354C27.9465 97.5354 51.0195 120.608 51.0195 149.07Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.557 355.21C102.557 326.748 125.63 303.675 154.092 303.675L154.092 406.745C125.63 406.745 102.557 383.672 102.557 355.21Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 355.21C234.088 355.21 257.161 378.283 257.161 406.745H154.091C154.091 378.283 177.164 355.21 205.626 355.21Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 252.141C234.088 252.141 257.161 275.214 257.161 303.676H154.091C154.091 275.214 177.164 252.141 205.626 252.141Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.768 45.1708C411.768 73.6328 388.695 96.7058 360.233 96.7058L360.233 -6.36423C388.695 -6.36423 411.768 16.7088 411.768 45.1708Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 45.1705C411.767 16.7085 434.84 -6.3645 463.302 -6.3645L463.302 96.7055C434.84 96.7055 411.767 73.6325 411.767 45.1705Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.838 96.7056C486.376 96.7056 463.303 73.6326 463.303 45.1705L566.373 45.1705C566.373 73.6326 543.3 96.7056 514.838 96.7056Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.908 -6.36425C646.37 -6.36426 669.443 16.7088 669.443 45.1708L566.373 45.1708C566.373 16.7088 589.446 -6.36425 617.908 -6.36425Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.443 45.1708C669.443 16.7088 692.516 -6.36426 720.978 -6.36426L720.978 96.7058C692.516 96.7058 669.443 73.6328 669.443 45.1708Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.443 355.21C697.905 355.21 720.978 378.283 720.978 406.745H617.908C617.908 378.283 640.981 355.21 669.443 355.21Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 355.21C640.98 355.21 617.907 332.137 617.907 303.675L720.977 303.675C720.977 332.137 697.904 355.21 669.442 355.21Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 252.14C640.98 252.141 617.907 229.067 617.907 200.605L720.977 200.605C720.977 229.067 697.904 252.14 669.442 252.14Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.441 149.07C669.441 120.608 692.514 97.5354 720.976 97.5354L720.976 200.605C692.514 200.605 669.441 177.532 669.441 149.07Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.372 252.14C537.91 252.141 514.837 229.067 514.837 200.605L617.907 200.605C617.907 229.067 594.834 252.14 566.372 252.14Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 149.071C669.442 177.533 646.369 200.606 617.907 200.606L617.907 97.5357C646.369 97.5357 669.442 120.609 669.442 149.071Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.371 97.5356C594.833 97.5356 617.906 120.609 617.906 149.071H514.836C514.836 120.609 537.909 97.5356 566.371 97.5356Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.836 252.141C514.836 223.679 491.763 200.606 463.301 200.606L463.301 303.676C491.763 303.676 514.836 280.603 514.836 252.141Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.768 355.21C440.23 355.21 463.303 378.283 463.303 406.745H360.233C360.233 378.283 383.306 355.21 411.768 355.21Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 355.21C383.305 355.21 360.232 332.137 360.232 303.675L463.302 303.675C463.302 332.137 440.229 355.21 411.767 355.21Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 252.14C383.305 252.141 360.232 229.067 360.232 200.605L463.302 200.605C463.302 229.067 440.229 252.14 411.767 252.14Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.301 200.605C434.839 200.605 411.766 177.532 411.766 149.07L514.836 149.07C514.836 177.532 491.763 200.605 463.301 200.605Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 149.07C411.766 177.532 388.693 200.605 360.231 200.605L360.231 97.5354C388.693 97.5354 411.766 120.608 411.766 149.07Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.303 355.21C463.303 326.748 486.376 303.675 514.838 303.675L514.838 406.745C486.376 406.745 463.303 383.672 463.303 355.21Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.372 355.21C594.834 355.21 617.907 378.283 617.907 406.745H514.837C514.837 378.283 537.91 355.21 566.372 355.21Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.372 252.141C594.834 252.141 617.907 275.214 617.907 303.676H514.837C514.837 275.214 537.91 252.141 566.372 252.141Z",
    fill: "#DED9D5"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M772.511 662.796C744.049 662.796 720.976 685.869 720.976 714.331H824.046C824.046 685.869 800.973 662.796 772.511 662.796Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.511 662.796C800.973 662.796 824.046 639.723 824.046 611.261L720.976 611.261C720.976 639.723 744.049 662.796 772.511 662.796Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.511 559.726C800.973 559.726 824.046 536.653 824.046 508.191L720.976 508.191C720.976 536.653 744.049 559.726 772.511 559.726Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.512 456.656C772.512 428.194 749.439 405.121 720.977 405.121L720.977 508.191C749.439 508.191 772.512 485.118 772.512 456.656Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.581 559.726C904.043 559.726 927.116 536.653 927.116 508.191L824.046 508.191C824.046 536.653 847.119 559.726 875.581 559.726Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.511 456.656C772.511 485.118 795.584 508.191 824.046 508.191L824.046 405.121C795.584 405.121 772.511 428.194 772.511 456.656Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.582 405.121C847.12 405.121 824.047 428.194 824.047 456.656H927.117C927.117 428.194 904.044 405.121 875.582 405.121Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.117 559.726C927.117 531.264 950.19 508.191 978.652 508.191L978.652 611.261C950.19 611.261 927.117 588.188 927.117 559.726Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 662.796C1001.72 662.796 978.65 685.869 978.65 714.331H1081.72C1081.72 685.869 1058.65 662.796 1030.19 662.796Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 662.796C1058.65 662.796 1081.72 639.723 1081.72 611.261L978.651 611.261C978.651 639.723 1001.72 662.796 1030.19 662.796Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 559.726C1058.65 559.726 1081.72 536.653 1081.72 508.191L978.651 508.191C978.651 536.653 1001.72 559.726 1030.19 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.652 508.191C1007.11 508.191 1030.19 485.118 1030.19 456.656L927.117 456.656C927.117 485.118 950.19 508.191 978.652 508.191Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 456.656C1030.19 485.118 1053.26 508.191 1081.72 508.191L1081.72 405.121C1053.26 405.121 1030.19 428.194 1030.19 456.656Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.65 662.796C978.65 634.334 955.577 611.261 927.115 611.261L927.115 714.331C955.577 714.331 978.65 691.258 978.65 662.796Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.581 662.796C847.119 662.796 824.046 685.869 824.046 714.331H927.116C927.116 685.869 904.043 662.796 875.581 662.796Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.581 559.726C847.119 559.726 824.046 582.799 824.046 611.261H927.116C927.116 582.799 904.043 559.726 875.581 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 766.696C1030.19 738.234 1053.26 715.161 1081.72 715.161L1081.72 818.231C1053.26 818.231 1030.19 795.158 1030.19 766.696Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.19 766.696C1030.19 795.158 1007.11 818.231 978.652 818.231L978.652 715.161C1007.11 715.161 1030.19 738.234 1030.19 766.696Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.115 715.161C955.577 715.161 978.65 738.234 978.65 766.696H875.58C875.58 738.234 898.653 715.161 927.115 715.161Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.045 818.23C795.583 818.23 772.51 795.157 772.51 766.695L875.58 766.695C875.58 795.157 852.507 818.23 824.045 818.23Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.51 766.695C772.51 795.157 749.437 818.23 720.975 818.23L720.975 715.16C749.437 715.16 772.51 738.233 772.51 766.695Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 456.656C1104.8 456.656 1081.72 433.583 1081.72 405.121H1184.79C1184.79 433.583 1161.72 456.656 1133.26 456.656Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 456.656C1161.72 456.656 1184.79 479.729 1184.79 508.191L1081.72 508.191C1081.72 479.729 1104.8 456.656 1133.26 456.656Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 559.726C1161.72 559.726 1184.79 582.799 1184.79 611.261L1081.72 611.261C1081.72 582.799 1104.8 559.726 1133.26 559.726Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 662.796C1133.26 691.258 1110.19 714.331 1081.72 714.331L1081.72 611.261C1110.19 611.261 1133.26 634.334 1133.26 662.796Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 559.726C1264.79 559.726 1287.86 582.799 1287.86 611.261L1184.79 611.261C1184.79 582.799 1207.87 559.726 1236.33 559.726Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 662.796C1133.26 634.334 1156.33 611.26 1184.79 611.261L1184.79 714.331C1156.33 714.331 1133.26 691.258 1133.26 662.796Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 714.331C1207.87 714.331 1184.79 691.258 1184.79 662.796H1287.86C1287.86 691.258 1264.79 714.331 1236.33 714.331Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 559.725C1287.86 588.187 1310.94 611.26 1339.4 611.26L1339.4 508.19C1310.94 508.19 1287.86 531.263 1287.86 559.725Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 456.656C1362.47 456.656 1339.4 433.583 1339.4 405.121H1442.47C1442.47 433.583 1419.39 456.656 1390.93 456.656Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 456.656C1419.39 456.656 1442.47 479.729 1442.47 508.191L1339.4 508.191C1339.4 479.729 1362.47 456.656 1390.93 456.656Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 559.726C1419.39 559.726 1442.47 582.799 1442.47 611.261L1339.4 611.261C1339.4 582.799 1362.47 559.726 1390.93 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.4 611.261C1367.86 611.261 1390.93 634.334 1390.93 662.796L1287.86 662.796C1287.86 634.334 1310.94 611.261 1339.4 611.261Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 662.796C1390.93 634.334 1414.01 611.261 1442.47 611.261L1442.47 714.331C1414.01 714.331 1390.93 691.258 1390.93 662.796Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.4 456.656C1339.4 485.118 1316.32 508.191 1287.86 508.191L1287.86 405.121C1316.32 405.121 1339.4 428.194 1339.4 456.656Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 456.656C1207.87 456.656 1184.79 433.583 1184.79 405.121H1287.86C1287.86 433.583 1264.79 456.656 1236.33 456.656Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.33 559.726C1207.87 559.726 1184.79 536.653 1184.79 508.191H1287.86C1287.86 536.653 1264.79 559.726 1236.33 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 766.696C1390.93 738.234 1414.01 715.161 1442.47 715.161L1442.47 818.231C1414.01 818.231 1390.93 795.158 1390.93 766.696Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.93 766.696C1390.93 795.158 1367.86 818.231 1339.4 818.231L1339.4 715.161C1367.86 715.161 1390.93 738.234 1390.93 766.696Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.86 715.161C1316.33 715.161 1339.4 738.234 1339.4 766.696H1236.33C1236.33 738.234 1259.4 715.161 1287.86 715.161Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.79 818.23C1156.33 818.23 1133.26 795.157 1133.26 766.695L1236.33 766.695C1236.33 795.157 1213.25 818.23 1184.79 818.23Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.26 766.695C1133.26 795.157 1110.18 818.23 1081.72 818.23L1081.72 715.16C1110.18 715.16 1133.26 738.233 1133.26 766.695Z",
    fill: "#C7CDBF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0194 662.796C22.5574 662.796 -0.515625 685.869 -0.515625 714.331H102.554C102.554 685.869 79.4814 662.796 51.0194 662.796Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0197 662.796C79.4817 662.796 102.555 639.723 102.555 611.261L-0.515346 611.261C-0.515348 639.723 22.5577 662.796 51.0197 662.796Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0197 559.726C79.4817 559.726 102.555 536.653 102.555 508.191L-0.515346 508.191C-0.515348 536.653 22.5577 559.726 51.0197 559.726Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0205 456.656C51.0205 428.194 27.9475 405.121 -0.514511 405.121L-0.51451 508.191C27.9475 508.191 51.0205 485.118 51.0205 456.656Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09 559.726C182.552 559.726 205.625 536.653 205.625 508.191L102.555 508.191C102.555 536.653 125.628 559.726 154.09 559.726Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0195 456.656C51.0195 485.118 74.0925 508.191 102.555 508.191L102.555 405.121C74.0925 405.121 51.0195 428.194 51.0195 456.656Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.091 405.121C125.629 405.121 102.556 428.194 102.556 456.656H205.626C205.626 428.194 182.553 405.121 154.091 405.121Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.626 559.726C205.626 531.264 228.699 508.191 257.161 508.191L257.161 611.261C228.699 611.261 205.626 588.188 205.626 559.726Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.694 662.796C280.232 662.796 257.159 685.869 257.159 714.331H360.229C360.229 685.869 337.156 662.796 308.694 662.796Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.694 662.796C337.156 662.796 360.229 639.723 360.229 611.261L257.159 611.261C257.159 639.723 280.232 662.796 308.694 662.796Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.694 559.726C337.156 559.726 360.229 536.653 360.229 508.191L257.159 508.191C257.159 536.653 280.232 559.726 308.694 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.161 508.191C285.623 508.191 308.696 485.118 308.696 456.656L205.626 456.656C205.626 485.118 228.699 508.191 257.161 508.191Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 456.656C308.696 485.118 331.769 508.191 360.231 508.191L360.231 405.121C331.769 405.121 308.696 428.194 308.696 456.656Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.159 662.796C257.159 634.334 234.086 611.261 205.624 611.261L205.624 714.331C234.086 714.331 257.159 691.258 257.159 662.796Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09 662.796C125.628 662.796 102.555 685.869 102.555 714.331H205.625C205.625 685.869 182.552 662.796 154.09 662.796Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09 559.726C125.628 559.726 102.555 582.799 102.555 611.261H205.625C205.625 582.799 182.552 559.726 154.09 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.695 766.695C308.695 738.233 331.768 715.16 360.23 715.16L360.23 818.23C331.768 818.23 308.695 795.157 308.695 766.695Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.696 766.696C308.696 795.158 285.623 818.231 257.161 818.231L257.161 715.161C285.623 715.161 308.696 738.234 308.696 766.696Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.625 715.161C234.087 715.161 257.16 738.234 257.16 766.696H154.09C154.09 738.234 177.163 715.161 205.625 715.161Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.555 818.23C74.0925 818.23 51.0195 795.157 51.0195 766.695L154.09 766.695C154.09 795.157 131.017 818.23 102.555 818.23Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0195 766.695C51.0195 795.157 27.9465 818.23 -0.515488 818.23L-0.515483 715.16C27.9465 715.16 51.0195 738.233 51.0195 766.695Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 456.656C383.304 456.656 360.231 433.583 360.231 405.121H463.301C463.301 433.583 440.228 456.656 411.766 456.656Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 456.656C440.229 456.656 463.302 479.729 463.302 508.191L360.232 508.191C360.232 479.729 383.305 456.656 411.767 456.656Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 559.726C440.229 559.726 463.302 582.799 463.302 611.261L360.232 611.261C360.232 582.799 383.305 559.726 411.767 559.726Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.768 662.796C411.768 691.258 388.695 714.331 360.233 714.331L360.233 611.261C388.695 611.261 411.768 634.334 411.768 662.796Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.837 559.726C543.299 559.726 566.372 582.799 566.372 611.261L463.302 611.261C463.302 582.799 486.375 559.726 514.837 559.726Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.767 662.796C411.767 634.334 434.84 611.26 463.302 611.261L463.302 714.331C434.84 714.331 411.767 691.258 411.767 662.796Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.838 714.331C486.376 714.331 463.303 691.258 463.303 662.796H566.373C566.373 691.258 543.3 714.331 514.838 714.331Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.373 559.725C566.373 588.187 589.446 611.26 617.908 611.26L617.908 508.19C589.446 508.19 566.373 531.263 566.373 559.725Z",
    fill: "#B17A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.441 456.656C640.979 456.656 617.906 433.583 617.906 405.121H720.976C720.976 433.583 697.903 456.656 669.441 456.656Z",
    fill: "#7C4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 456.656C697.904 456.656 720.977 479.729 720.977 508.191L617.907 508.191C617.907 479.729 640.98 456.656 669.442 456.656Z",
    fill: "#ECD3A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 559.726C697.904 559.726 720.977 582.799 720.977 611.261L617.907 611.261C617.907 582.799 640.98 559.726 669.442 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.908 611.261C646.37 611.261 669.443 634.334 669.443 662.796L566.373 662.796C566.373 634.334 589.446 611.261 617.908 611.261Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.443 662.796C669.443 634.334 692.516 611.261 720.978 611.261L720.978 714.331C692.516 714.331 669.443 691.258 669.443 662.796Z",
    fill: "#C7CDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.906 456.656C617.906 485.118 594.833 508.191 566.371 508.191L566.371 405.121C594.833 405.121 617.906 428.194 617.906 456.656Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.837 456.656C486.375 456.656 463.302 433.583 463.302 405.121H566.372C566.372 433.583 543.299 456.656 514.837 456.656Z",
    fill: "#DDEDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.837 559.726C486.375 559.726 463.302 536.653 463.302 508.191H566.372C566.372 536.653 543.299 559.726 514.837 559.726Z",
    fill: "#DED9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.441 766.695C669.441 738.233 692.514 715.16 720.976 715.16L720.976 818.23C692.514 818.23 669.441 795.157 669.441 766.695Z",
    fill: "#D6973F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.442 766.696C669.442 795.158 646.369 818.231 617.907 818.231L617.907 715.161C646.369 715.161 669.442 738.234 669.442 766.696Z",
    fill: "#7C856C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.371 715.161C594.833 715.161 617.906 738.234 617.906 766.696H514.836C514.836 738.234 537.909 715.161 566.371 715.161Z",
    fill: "#CE9FA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.301 818.23C434.839 818.23 411.766 795.157 411.766 766.695L514.836 766.695C514.836 795.157 491.763 818.23 463.301 818.23Z",
    fill: "#C2E1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.766 766.695C411.766 795.157 388.693 818.23 360.231 818.23L360.231 715.16C388.693 715.16 411.766 738.233 411.766 766.695Z",
    fill: "#C7CDBF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 780,
    fill: "white",
    transform: "translate(0.976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.ad6ae077.svg";
export { ForwardRef as ReactComponent };